import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import ruTranslations from '../../locales/ru.json'
import enTranslations from '../../locales/en.json'
import esTranslations from '../../locales/es.json'
import ptTranslations from '../../locales/pt.json'
import plTranslations from '../../locales/pl.json'
import trTranslations from '../../locales/tr.json'
import roTranslations from '../../locales/ro.json'
import uzTranslations from '../../locales/uz.json'
import uaTranslations from '../../locales/ua.json'

// ВЕРСИЯ ПЕРЕВОДОВ - изменяй при обновлении переводов для очистки кэша
const TRANSLATIONS_VERSION = 'v2.2'

// Проверка и очистка устаревшего кэша переводов
const currentVersion = localStorage.getItem('i18n_version')
if (currentVersion !== TRANSLATIONS_VERSION) {
    console.log('🔄 Очистка старого кэша переводов:', currentVersion, '→', TRANSLATIONS_VERSION)
    // Очищаем только языковой кэш, не трогая токены и другие данные
    const keysToRemove = ['i18nextLng', 'languageSource', 'translationCache']
    keysToRemove.forEach(key => localStorage.removeItem(key))
    localStorage.setItem('i18n_version', TRANSLATIONS_VERSION)
    console.log('✅ Кэш переводов очищен, версия обновлена')
}

const resources = {
    ru: {
        translation: ruTranslations,
    },
    en: {
        translation: enTranslations,
    },
    es: {
        translation: esTranslations,
    },
    pt: {
        translation: ptTranslations,
    },
    pl: {
        translation: plTranslations,
    },
    tr: {
        translation: trTranslations,
    },
    ro: {
        translation: roTranslations,
    },
    uz: {
        translation: uzTranslations,
    },
    ua: {
        translation: uaTranslations,
    },
}

// КРИТИЧНО: Приоритет языков
// 1. localStorage (язык из API или выбранный вручную) - устанавливается в useAuth
// 2. Telegram WebApp language (fallback если нет в localStorage)
// 3. Browser navigator language
// 4. Fallback на 'en' (английский по умолчанию)

i18n.use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources,
        
        // ВАЖНО: fallbackLng - что показывать если перевод НЕ найден
        // Так как не все ключи переведены во всех языках - fallback на RU (самый полный)
        fallbackLng: 'ru',
        
        defaultNS: 'translation',
        debug: false, // Выключаем debug для production
        
        // Явно указываем поддерживаемые языки
        supportedLngs: ['ru', 'en', 'es', 'pt', 'pl', 'tr', 'ro', 'uz', 'ua'],
        
        // Загружать только код языка без региона (en вместо en-US)
        load: 'languageOnly',
        
        // НЕ добавлять неявные поддерживаемые языки
        nonExplicitSupportedLngs: false,
        
        interpolation: {
            escapeValue: false,
        },
        
        detection: {
            // Порядок определения языка
            order: ['localStorage', 'navigator'],
            caches: ['localStorage'],
            lookupLocalStorage: 'i18nextLng',
            // Нормализация языка при определении (en-US -> en, pt-BR -> pt)
            convertDetectedLanguage: (lng) => {
                if (!lng) return lng
                const normalized = lng.toLowerCase().split('-')[0]
                const langMap = { 'uk': 'ua' }
                const result = langMap[normalized] || normalized
                console.log('🔄 convertDetectedLanguage:', lng, '→', result)
                return result
            },
        },
    })
    
// Логируем загруженный язык при инициализации
i18n.on('initialized', (options) => {
    console.log('🌍 i18n initialized:', {
        language: i18n.language,
        languages: i18n.languages,
        hasResources: Object.keys(i18n.store.data).length > 0,
        availableLanguages: Object.keys(resources)
    })
})

// Логируем смену языка
i18n.on('languageChanged', (lng) => {
    console.log('🌍 i18n language changed to:', lng, {
        hasTranslations: !!i18n.store.data[lng],
        translationKeys: i18n.store.data[lng] ? Object.keys(i18n.store.data[lng].translation || {}).length : 0
    })
})

export default i18n
